import constants from '@/constants'
import { LastErrorStore, AuthStore } from '@/stores'
import axios from 'axios'

/**
 * Root REST calls.
 */
const HEADER_CALL = {
  'Content-Type': 'application/json',
  Authorization: 'set_it_before_call_please',
  'Cache-Control': 'no-cache',
  Pragma: 'no-cache',
  Expires: '0'
}

export const AxiosCallPost = async function (subUrl, data) {
  // get credential if defined
  const as = AuthStore()
  HEADER_CALL.Authorization = as.AuthInfos?.credential ? 'Basic ' + as.AuthInfos?.credential : null
  const realUrl = constants.api_url + '/' + subUrl
  const toput = data ? JSON.stringify(data) : null

  const check = await axios.post(`${realUrl}`, toput, {headers: HEADER_CALL})
    .catch(error => {
      LastErrorStore().NotifyError(error.message)
    })
  return check?.data ?? {error: true}
}

export const AxiosCallPostWithErr = async function (subUrl, data, cbk) {
  const res = await AxiosCallPost(subUrl, data)
  if (res && res.result) {
    cbk(res.result)
    return true
  } else {
    LastErrorStore().NotifyError('Can\'t execute remote call')
  }
  return false
}

export const AxiosCallPostWithErr2 = async function (subUrl, data) {
  const res = await AxiosCallPost(subUrl, data)
  if (res) {
    return res
  } else {
    LastErrorStore().NotifyError('Can\'t execute remote call')
  }
  return null
}
